var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.96 18.96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-up-right_svg__cls-1{fill:#e81f76}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-right_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arrow-up-right_svg__cls-1",
    d: "M1.97 18.96L15.99 4.94l-.43 11.7 2.79.1L18.96 0 2.22.61l.1 2.79 11.7-.43L0 16.99l1.97 1.97z",
    id: "arrow-up-right_svg__NAV"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOC45NiAxOC45NiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlODFmNzY7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJOQVYiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxLjk3IDE4Ljk2IDE1Ljk5IDQuOTQgMTUuNTYgMTYuNjQgMTguMzUgMTYuNzQgMTguOTYgMCAyLjIyIDAuNjEgMi4zMiAzLjQgMTQuMDIgMi45NyAwIDE2Ljk5IDEuOTcgMTguOTYiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgArrowUpRight as ReactComponent };